import PropTypes from 'prop-types';

//
export const OEPresetType = {
    unknown:                            0,
    any:                                1,
    dummy:                              2,
    note:                               3,
    camera:                             4,
    cut:                                5,
    color:                              6,
    components:                         7
};

OEPresetType.all = Object.values(OEPresetType);

OEPresetType.stringTable = ['unknown', 'any', 'dummy', 'note', 'camera', 'cut', 'color', 'components'];

OEPresetType.toString = function(type) {
        return typeof(type) !== 'number' || type < 0 || type >= OEPresetType.stringTable.length ? undefined : OEPresetType.stringTable[type];
};

//
export const OEPresetSetType = {
    none:                               0,
    static:                             1,
    modelState:                         2,
    all:                                3
};

//
export const OEPresetResult = {
    ok:                                 0,
    uiLock:                             1,
    refToVoid:                          2,
    fileCorrupt:                        3,
    wrongType:                          4,
    unknownType:                        5,
    couldNotOpenFile:                   6,
    invalidType:                        7,
    noPresetsFound:                     8,
    unexpected:                         9,

    stringTable: ['ok', 'uiLock', 'refToVoid', 'fileCorrupt', 'wrongType', 'unknownType', 'couldNotOpenFile', 'invalidType', 'noPresetsFound', 'unexpected'],

    toString: function(type) {
        return typeof(type) !== 'number' || type < 0 || type >= this.stringTable.length ? undefined : this.stringTable[type];
    }
};

//
export const OEPresetTypeHelper = {

    presetTypeToArray(type) {
        if(Array.isArray(type)) return type;
        if(typeof(type) === 'number') return [type];
        return [];
    },

    presetTypeFromCore(type)    {
        if(Array.isArray(type)) return type.map(e => e.value);
        if(type) return type.value;
    },

    presetTypeToCore(type)  {
        if(Array.isArray(type)) return type.map(e =>  {
            return {value: e};
        });

        if(typeof(type) === 'number')   return {value: type};
    },

    presetTypeDecl: PropTypes.oneOf(OEPresetType.all),

    presetTypeNumberDecl: PropTypes.number,
};

OEPresetTypeHelper.presetTypeArrayDecl = PropTypes.oneOfType([OEPresetTypeHelper.presetTypeDecl, PropTypes.arrayOf(OEPresetTypeHelper.presetTypeDecl)]);

OEPresetTypeHelper.presetTypeNumberArrayDecl = PropTypes.oneOfType([OEPresetTypeHelper.presetTypeNumberDecl, PropTypes.arrayOf(OEPresetTypeHelper.presetTypeNumberDecl)]);